import { specials } from "@/mocks/gossipData";

export default function Special() {
  return (
    <section id="special" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">Deep Dive</p>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">深度盘点</h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600">
              不止吃瓜，更讲清楚来龙去脉。编辑部精选本周值得深读的专题，帮你理性吃瓜。
            </p>
          </div>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-3">
          {specials.map((s, i) => (
            <article
              key={s.id}
              className={
                "group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 " +
                (i === 0 ? "lg:col-span-2" : "")
              }
            >
              <div className="relative overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className={
                    "w-full object-cover transition-transform duration-300 group-hover:scale-105 " +
                    (i === 0 ? "h-64 lg:h-80" : "h-52")
                  }
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  {s.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  约 {s.read} 读完
                </div>
                <h3 className="font-heading mt-2 text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-600">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.summary}</p>
                <ul className="mt-4 space-y-2">
                  {s.points.map((p, idx) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-foreground-700">
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-[11px] font-bold text-accent-800">
                        {idx + 1}
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}